import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useEffect, useState } from "react";
import { getAccountById, getAccountPatients } from "../api";
import { useParams } from "react-router-dom";
import { EditAccount } from "../Components/PatientsAccounts/EditAccounts";
import { NotesHistory } from "../Components/PatientsAccounts/AccountNotes";

import AccountStatements from "../Components/Accounts/AccountStatements";

export function Accounts() {
  const [patient, setPatient] = useState({});
  const [account, setAccount] = useState();
  const [modalShow, setModalShow] = useState(false);
  const { id } = useParams();
  const [activeSection, setActiveSection] = useState("account");
  const [dependants, setDependants] = useState([]);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toISOString().slice(0, 16).replace("T", " "); // Extracts yyyy-mm-dd HH:MM
  };

  useEffect(() => {
    async function getAccountInfo() {
      try {
        const accountData = await getAccountById(id);
        setAccount(accountData);
        console.log(accountData);
      } catch (error) {
        console.error("Error fetching account data:", error);
      }
    }
    getAccountInfo();
  }, [id]);

  useEffect(() => {
    async function loadDependants() {
      try {
        if (!account?._id) return; // Ensure account exists before fetching
        const dependantsData = await getAccountPatients(id);

        // ✅ Ensure it's always an array
        setDependants(Array.isArray(dependantsData) ? dependantsData : []);
      } catch (error) {
        console.error("Error fetching dependants data:", error);
        setDependants([]); // Set to empty array on error
      }
    }
    loadDependants();
  }, [id, account]); // ✅ Ensure it runs when `account` changes

  function renderAccountInfo() {
    if (!account || !account?._id) {
      return <p>Loading account information...</p>;
    }

    return (
      <div>
        <Row className="align-items-center mb-3">
          {/* Main Data Column (10) */}
          <Col md={10}>
            {/* Full-width Row: Account Name */}
            <Row className="mb-2">
              <Col md={12}>
                <h6 className="text-primary">
                  {account?.accountTitle} {account?.accountFullNames}{" "}
                  {account?.accountLastName} ({account?.accountFirstName})
                </h6>
              </Col>
            </Row>

            {/* Three Equal Columns */}
            <Row>
              {/* Column 1: Personal Details */}
              <Col md={4}>
                {account?.accountIdNumber && (
                  <>
                    <i className="fa-solid fa-id-card me-1 text-primary"></i>{" "}
                    {account?.accountIdNumber} <br />
                  </>
                )}
                {account?.accountCellNumber && (
                  <>
                    <i className="fas fa-phone-alt me-2 text-primary"></i>{" "}
                    {account?.accountCellNumber} <br />
                  </>
                )}
                {account?.accountEmail && (
                  <>
                    <i className="fas fa-envelope me-2 text-primary"></i>{" "}
                    {account.accountEmail} <br />
                  </>
                )}
              </Col>

              {/* Column 2: Address */}
              <Col md={4}>
                {account?.accountHomeAddress1 && (
                  <>
                    <i className="fas fa-map-marker-alt me-2 text-primary"></i>{" "}
                    {account?.accountHomeAddress1} <br />
                  </>
                )}
                {account?.accountHomeAddress2 && (
                  <>
                    <i className="fas fa-map-marker-alt me-2 text-white"></i>{" "}
                    {account?.accountHomeAddress2} <br />
                  </>
                )}
                {(account?.accountHomeAddressCity ||
                  account?.accountHomeAddressPostalCode) && (
                  <>
                    <i className="fas fa-map-marker-alt me-2 text-white"></i>{" "}
                    {account?.accountHomeAddressCity}
                    {account?.accountHomeAddressCity &&
                      account?.accountHomeAddressPostalCode &&
                      ", "}
                    {account?.accountHomeAddressPostalCode} <br />
                  </>
                )}
              </Col>

              {/* Column 3: Work Info */}
              <Col md={4}>
                {account?.accountOccupation && (
                  <>
                    <i className="fas fa-briefcase me-2 text-primary"></i>{" "}
                    {account?.accountOccupation} <br />
                  </>
                )}
                {account?.accountEmployer && (
                  <>
                    <i className="fas fa-building me-2 text-primary"></i>{" "}
                    {account?.accountEmployer} <br />
                  </>
                )}
                {account?.accountTelNumberWork && (
                  <>
                    <i className="fas fa-phone-alt me-2 text-primary"></i>{" "}
                    {account?.accountTelNumberWork} <br />
                  </>
                )}
              </Col>
            </Row>
          </Col>

          {/* Button Column (2) */}
        </Row>
        <Row className="mb-3">
          <Col md={7} className="d-flex justify-content-start gap-2 w-25">
            <EditAccount account={account} show={modalShow} />
            <NotesHistory show={modalShow} account={account} />
          </Col>
        </Row>
      </div>
    );
  }

  function renderMedicalAidInformation() {
    if (!account || !account._id) {
      return <p>Loading account information...</p>;
    }
    const getStatusClass = (status) =>
  status?.toLowerCase().includes("active") ? "text-success" : "text-danger";

    // ✅ Sort dependants by patientMedicalAidDependantCode (numerically)
    const sortedDependants = [...dependants].sort((a, b) => {
      return (
        parseInt(a.patientMedicalAidDependantCode) -
        parseInt(b.patientMedicalAidDependantCode)
      );
    });

    return (
      <div>
        <Row className="mb-1">
          {/* Left Column: Medical Aid & Dependants */}
          <Col md={10}>
            <Row>
              {/* Medical Aid Section */}
              <Col md={3}>
                <h6 className="text-primary">Medical Aid</h6>
                {account?.accountMedicalAid ? (
                  <>
                    <i className="fa fa-notes-medical me-2 text-primary"></i>{" "}
                    {account?.accountMedicalAid} <br />
                    <i className="fa fa-notes-medical me-2 text-white"></i>{" "}
                    {account?.accountMedicalAidPlan} |{" "}
                    {account?.accountMedicalAidOption} <br />
                    <i className="fa fa-notes-medical me-2 text-white"></i>{" "}
                    {account?.accountMedicalAidNumber} <br />
                  </>
                ) : (
                  <p className="text-primary">
                    <i className="fa fa-notes-medical me-2 text-primary"></i>{" "}
                    This is a Private account
                  </p>
                )}
              </Col>

              {/* Dependants Section */}
              <Col md={9}>
                <h6 className="text-primary">Dependants</h6>
                {sortedDependants.length > 0 ? (
                  <Row as="ul" className="list-unstyled">
                    {sortedDependants.map((patient) => (
                      <Row
                        as="li"
                        key={patient?._id}
                        className="d-flex align-items-start mb-1"
                      >
                        {/* Column 1: Dependant Code - First Name Last Name */}
                        <Col md={4}>
                          <li>
                            {patient?.patientMedicalAidDependantCode} -{" "}
                            {patient?.patientFirstName} {patient?.patientLastName}
                          </li>
                        </Col>

                        {/* ✅ Only show Status, Join Date, and Last Checked if Medical Aid exists */}
                        {account?.accountMedicalAid && (
                          <>
                            {/* Column 2: Status - Join Date */}
                            <Col md={4}>
                              <li
                                className={getStatusClass(
                                  patient?.patientMedicalAidStatus
                                )}
                              >
                                {patient?.patientMedicalAidStatus}{" "}
                                {patient?.patientMedicalAidJoinDate}
                              </li>
                            </Col>

                            {/* Column 3: Last Checked */}
                            <Col md={4} className="text-start">
                              <li className="text-muted">
                                checked:{" "}
                                {formatDate(patient?.patientMedicalAidLastCheck)}
                              </li>
                            </Col>
                          </>
                        )}
                      </Row>
                    ))}
                  </Row>
                ) : (
                  <p>No associated patients found.</p>
                )}
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    );
  }

  return (
    <div>
      <div style={{ marginTop: "75px", position: "relative" }} className="ms-3">
        <div
          className="container-fluid px-4 px-md-1 bg-white pt-3"
          style={{ maxWidth: "1400px" }}
        >
          {/* 🔹 Row for Tabs and Hide Button */}
          <Row className="d-flex justify-content-between align-items-center mb-2">
            {/* ✅ Column for Navigation Tabs (Left-Aligned) */}
            <Col md={10}>
              <div className="d-flex align-items-center">
                <h5
                  className={`fw-normal d-inline me-3 ${
                    activeSection === "account"
                      ? "text-primary"
                      : "text-secondary fw-light"
                  }`}
                  style={{ cursor: "pointer" }}
                  onClick={() => setActiveSection("account")}
                >
                  Account Information
                </h5>
                <span className="text-secondary mx-3">|</span>
                <h5
                  className={`fw-normal d-inline ${
                    activeSection === "medicalAid"
                      ? "text-primary"
                      : "text-secondary fw-light"
                  }`}
                  style={{ cursor: "pointer" }}
                  onClick={() => setActiveSection("medicalAid")}
                >
                  Medical Aid Information
                </h5>
              </div>
            </Col>
          </Row>

          {/* 🔹 Content Based on Active Tab */}
          <Row className="ms-1 mb-1">
            {activeSection === "account" && renderAccountInfo()}
            {activeSection === "medicalAid" && renderMedicalAidInformation()}
          </Row>
        </div>
      </div>
      <hr />
      <Row className="d-flex justify-content-start ms-3 align-items-end"></Row>

      <Row className="ms-1">
        <AccountStatements account={account} />
      </Row>
    </div>
  );
}
